/* eslint-disable prettier/prettier */
import { FC } from "react";

interface CardProps {
  name: string;
  vendor: string;
  year: string | number;
  fromDate?: string;
  active?: boolean;
  archived?: boolean;
  onToggle?: () => void;
  edition: string;
  onViewMore?: () => void;
}

const styles = {
  container:
    "shadow-lg shadow-gray/70 m-4 text-gray-950 rounded-lg bg-gray-400 p-4 bg-gray-400 @max-[275px] w-[350px] flex flex-col",
  name: "flex-1 pb-3 font-bold pt-2 text-lg text-CostcoAction-pressed",
  vendor: "pt-2 space-x-2 text-md",
  edition: "pb-2 space-x-2",
  viewMore:
    "mt-3 text-sm font-semibold text-CostcoAction underline hover:text-CostcoAction-hover cursor-pointer bg-transparent border-none p-0 self-start",
};

const IndexCard: FC<CardProps> = ({
  name,
  vendor,
  edition,
  archived = false,
  onViewMore,
}) => {
  return (
    <div className={styles.container}>
      <div className={`${styles.name}`}>{name}</div>
      <div className={styles.vendor}>
        <label className="font-semibold">Source</label>
        <label>{vendor}</label>
      </div>
      <div className={styles.edition}>
        <label className="font-semibold">Edition</label>
        <label>{edition}</label>
      </div>
      {!archived && (
        <button type="button" className={styles.viewMore} onClick={onViewMore}>
          View More
        </button>
      )}
    </div>
  );
};

export default IndexCard;
